// Vendor libraries
import { ElementRef } from '@angular/core';
// Utils / constants
import { GUIDED_WORKFLOWS_FEATURE } from 'EntitlementsApp/ts/features/feature-needed/feature-needed.constants';
import { GUIDED_WORKFLOWS_OPEN_SUBCATEGORY_COOKIE_NAME } from 'QuickflowsApp/ts/constants';
import { SECURITY_ID_REGEX_SOURCE } from 'SecuritiesApp/ts/constants/security-ids.constants';
// Services
import { CookieService } from 'ngx-cookie-service';
import { FeatureService } from 'EntitlementsApp/ts/features/feature-needed/feature.service';
import { GuidedWorkflowsService } from 'GuidedWorkflowsApp/ts/services/guided-workflows.service';
import { UrlsService } from 'NewAngular/services/core/urls.service';
// Components
import { GuidedWorkflowsMenuComponent } from 'GuidedWorkflowsApp/ts/features/guided-workflows-menu/components/guided-workflows-menu.component';
import * as i0 from "@angular/core";
import * as i1 from "NewAngular/services/core/urls.service";
import * as i2 from "EntitlementsApp/ts/features/feature-needed/feature.service";
import * as i3 from "ngx-cookie-service";
import * as i4 from "GuidedWorkflowsApp/ts/services/guided-workflows.service";
import * as i5 from "@angular/common";
import * as i6 from "QuickflowsApp/ts/features/quickflows-menu/components/quickflows-menu.component";
import * as i7 from "../../../../../../apps/guided_workflows/static/guided_workflows/ts/features/guided-workflows-menu/components/guided-workflows-menu.component";
import * as i8 from "../../directives/icon/icon.directive";
import * as i9 from "../../directives/popovers/tooltip/tooltip.directive";
const _c0 = a0 => ({ "d-none": a0 });
const _c1 = a0 => ({ "side-menu-opened": a0 });
const _c2 = a0 => ({ active: a0 });
function SideMenuComponent_Conditional_0_Conditional_7_Template(rf, ctx) { if (rf & 1) {
    const _r3 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 7)(1, "button", 8);
    i0.ɵɵlistener("click", function SideMenuComponent_Conditional_0_Conditional_7_Template_button_click_1_listener() { i0.ɵɵrestoreView(_r3); const ctx_r1 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r1.togglePanel("quickflows")); });
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelement(2, "svg", 2);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(5, _c2, ctx_r1.isSidePanelOpen && ctx_r1.type == "quickflows"))("tooltipTitle", "Quickflows")("tooltipPlacement", "left")("tooltipIgnoreViewport", true);
    i0.ɵɵadvance();
    i0.ɵɵproperty("name", "icon-quickflows-color");
} }
function SideMenuComponent_Conditional_0_Conditional_8_Template(rf, ctx) { if (rf & 1) {
    const _r4 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 7)(1, "button", 9);
    i0.ɵɵlistener("click", function SideMenuComponent_Conditional_0_Conditional_8_Template_button_click_1_listener() { i0.ɵɵrestoreView(_r4); const ctx_r1 = i0.ɵɵnextContext(2); return i0.ɵɵresetView(ctx_r1.togglePanel("workflows")); });
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelement(2, "svg", 2);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(5, _c2, ctx_r1.isSidePanelOpen && ctx_r1.type == "workflows"))("tooltipTitle", "Workflows")("tooltipPlacement", "left")("tooltipIgnoreViewport", true);
    i0.ɵɵadvance();
    i0.ɵɵproperty("name", "icon-workflows-color");
} }
function SideMenuComponent_Conditional_0_Template(rf, ctx) { if (rf & 1) {
    const _r1 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "button", 1);
    i0.ɵɵlistener("click", function SideMenuComponent_Conditional_0_Template_button_click_0_listener() { i0.ɵɵrestoreView(_r1); const ctx_r1 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r1.toggleMenu()); });
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelement(1, "svg", 2);
    i0.ɵɵelementEnd();
    i0.ɵɵnamespaceHTML();
    i0.ɵɵelementStart(2, "div", 3)(3, "div", 4)(4, "div", 5)(5, "button", 6);
    i0.ɵɵlistener("click", function SideMenuComponent_Conditional_0_Template_button_click_5_listener() { i0.ɵɵrestoreView(_r1); const ctx_r1 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r1.toggleMenu()); });
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelement(6, "svg", 2);
    i0.ɵɵelementEnd()();
    i0.ɵɵtemplate(7, SideMenuComponent_Conditional_0_Conditional_7_Template, 3, 7, "div", 7)(8, SideMenuComponent_Conditional_0_Conditional_8_Template, 3, 7, "div", 7);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(12, _c0, ctx_r1.isMenuOpen))("tooltipTitle", "Open Menu")("tooltipPlacement", "left")("tooltipIgnoreViewport", true);
    i0.ɵɵadvance();
    i0.ɵɵproperty("name", "icon-close-arrow");
    i0.ɵɵadvance();
    i0.ɵɵproperty("ngClass", i0.ɵɵpureFunction1(14, _c1, ctx_r1.isMenuOpen));
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("tooltipTitle", "Close")("tooltipPlacement", "left")("tooltipIgnoreViewport", true);
    i0.ɵɵadvance();
    i0.ɵɵproperty("name", "icon-close");
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r1.showQuickflows ? 7 : -1);
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r1.categories.length > 0 && ctx_r1.showWorkflows ? 8 : -1);
} }
function SideMenuComponent_Conditional_1_Conditional_3_Conditional_3_Template(rf, ctx) { if (rf & 1) {
    const _r6 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "a", 19);
    i0.ɵɵlistener("click", function SideMenuComponent_Conditional_1_Conditional_3_Conditional_3_Template_a_click_0_listener() { i0.ɵɵrestoreView(_r6); const ctx_r1 = i0.ɵɵnextContext(3); return i0.ɵɵresetView(ctx_r1.clearSteps()); });
    i0.ɵɵtext(1, "Back to Workflow Categories");
    i0.ɵɵelementEnd();
} }
function SideMenuComponent_Conditional_1_Conditional_3_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div")(1, "div", 17);
    i0.ɵɵtext(2, "Workflows");
    i0.ɵɵelementEnd();
    i0.ɵɵtemplate(3, SideMenuComponent_Conditional_1_Conditional_3_Conditional_3_Template, 2, 0, "a", 18);
    i0.ɵɵelementEnd();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(3);
    i0.ɵɵconditional(ctx_r1.workflowsMenuComponent && ctx_r1.workflowsMenuComponent.selectedSteps.length > 0 ? 3 : -1);
} }
function SideMenuComponent_Conditional_1_Conditional_4_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelementStart(0, "div", 13)(1, "div", 17);
    i0.ɵɵtext(2, "Quickflows");
    i0.ɵɵelementEnd();
    i0.ɵɵelementStart(3, "a", 20);
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelement(4, "svg", 2);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("href", ctx_r1.userPreferencesUrl, i0.ɵɵsanitizeUrl)("tooltipTitle", "Quickflows Preferences");
    i0.ɵɵadvance();
    i0.ɵɵproperty("name", "icon-gear");
} }
function SideMenuComponent_Conditional_1_Conditional_7_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "ycn-quickflows-menu", 15);
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("displaySecurityId", ctx_r1.displaySecurityId)("securityId", ctx_r1.securityId)("securityName", ctx_r1.securityName)("securityUrl", ctx_r1.securityUrl);
} }
function SideMenuComponent_Conditional_1_Conditional_8_Template(rf, ctx) { if (rf & 1) {
    i0.ɵɵelement(0, "ycn-guided-workflows-menu", 16);
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext(2);
    i0.ɵɵproperty("pagePath", ctx_r1.pagePath)("categories", ctx_r1.categories)("selectedSubcategoryId", ctx_r1.selectedSubcategoryId);
} }
function SideMenuComponent_Conditional_1_Template(rf, ctx) { if (rf & 1) {
    const _r5 = i0.ɵɵgetCurrentView();
    i0.ɵɵelementStart(0, "div", 10)(1, "div", 11)(2, "div", 12);
    i0.ɵɵtemplate(3, SideMenuComponent_Conditional_1_Conditional_3_Template, 4, 1, "div")(4, SideMenuComponent_Conditional_1_Conditional_4_Template, 5, 3, "div", 13);
    i0.ɵɵelementStart(5, "button", 14);
    i0.ɵɵlistener("click", function SideMenuComponent_Conditional_1_Template_button_click_5_listener() { i0.ɵɵrestoreView(_r5); const ctx_r1 = i0.ɵɵnextContext(); return i0.ɵɵresetView(ctx_r1.closeMenu()); });
    i0.ɵɵnamespaceSVG();
    i0.ɵɵelement(6, "svg", 2);
    i0.ɵɵelementEnd()();
    i0.ɵɵtemplate(7, SideMenuComponent_Conditional_1_Conditional_7_Template, 1, 4, "ycn-quickflows-menu", 15)(8, SideMenuComponent_Conditional_1_Conditional_8_Template, 1, 3, "ycn-guided-workflows-menu", 16);
    i0.ɵɵelementEnd()();
} if (rf & 2) {
    const ctx_r1 = i0.ɵɵnextContext();
    i0.ɵɵstyleProp("top", ctx_r1.sidePanelTop, "px");
    i0.ɵɵadvance();
    i0.ɵɵstyleProp("height", ctx_r1.sidePanelHeight);
    i0.ɵɵadvance(2);
    i0.ɵɵconditional(ctx_r1.type === "workflows" ? 3 : ctx_r1.type === "quickflows" ? 4 : -1);
    i0.ɵɵadvance(3);
    i0.ɵɵproperty("name", "icon-close");
    i0.ɵɵadvance();
    i0.ɵɵconditional(ctx_r1.type === "quickflows" ? 7 : ctx_r1.type === "workflows" ? 8 : -1);
} }
/**
 *
 * Side Menu Component
 *
 * Hosts app side tabs QuickflowsMenuComponent and GuidedWorkflowsMenuComponent.
 * Quickflows component inputs:
 *   displaySecurityId: The display security ID to initialize this component with, e.g. VTSAX
 *   securityId: The security ID to initialize this component with, e.g. M:VTSAX
 *   securityName: The security name to initialize this component with, e.g. Vanguard Financials Index Admiral
 *   securityUrl: The security url to navigate e.g.  /mutual_funds/M:VFAIX
 *
 * Workflows component inputs:
 *  pagePath: the page path url to get categories
 *
 */
export class SideMenuComponent {
    onScrollEvent() {
        const sidePanel = this.eltRef.nativeElement.querySelector('.side-panel.open');
        if (sidePanel && window.getComputedStyle(sidePanel).position === 'fixed') {
            this.sidePanelTop = Math.max(0, this.headerHeight - window.scrollY);
        }
        else {
            this.sidePanelTop = undefined;
        }
        this.sidePanelHeight =
            window.scrollY < this.headerHeight ? `calc(100vh - ${this.headerHeight - window.scrollY}px)` : '100vh';
    }
    constructor(eltRef, urlsService, featureService, cookieService, guidedWorkflowsService) {
        this.eltRef = eltRef;
        this.urlsService = urlsService;
        this.featureService = featureService;
        this.cookieService = cookieService;
        this.guidedWorkflowsService = guidedWorkflowsService;
        this.showQuickflows = true;
        this.isSidePanelOpen = false;
        this.isMenuOpen = false;
        this.type = 'quickflows';
        this.userPreferencesUrl = '';
        this.showWorkflows = false;
        this.categories = [];
        this.selectedSubcategoryId = null;
        this.headerHeight = 48;
        this.displaySecurityId = this.eltRef.nativeElement.getAttribute('displaySecurityId');
        this.securityId = this.eltRef.nativeElement.getAttribute('securityId');
        this.securityName = this.eltRef.nativeElement.getAttribute('securityName');
        this.securityUrl = this.eltRef.nativeElement.getAttribute('securityUrl');
        this.showQuickflows = JSON.parse(this.eltRef.nativeElement.getAttribute('showQuickflows')) ?? true;
        this.pagePath = this.eltRef.nativeElement.getAttribute('pagePath');
    }
    ngOnInit() {
        this.userPreferencesUrl = this.urlsService.ACCOUNTS.QUICKFLOWS;
        const hasGuidedWorkflowsFeature = this.featureService.userHasFeatures([GUIDED_WORKFLOWS_FEATURE]);
        const subcategoryCookie = this.cookieService.get(GUIDED_WORKFLOWS_OPEN_SUBCATEGORY_COOKIE_NAME) || '""';
        const subcategorySelectedId = JSON.parse(decodeURIComponent(subcategoryCookie));
        const unhashedLocation = window.location.toString().replace('/#/', '/');
        const newURL = new URL(unhashedLocation);
        const queryParams = new URLSearchParams(newURL.search);
        const guidedWorkFlow = queryParams.get('gw');
        const querySubcategoryId = guidedWorkFlow == null || Number.isNaN(guidedWorkFlow) ? null : Number(guidedWorkFlow);
        if (this.pagePath === undefined || this.pagePath === null) {
            this.pagePath = this.getPathName(window.location.pathname);
        }
        this.showWorkflows = hasGuidedWorkflowsFeature;
        if (this.pagePath) {
            this.guidedWorkflowsService.getPageGuidedWorkflows(this.pagePath).subscribe((categories) => {
                this.categories = categories;
                const allSubcategories = categories.reduce((accumulator, category) => accumulator.concat(category.subcategories), []);
                const selectedCategoryId = querySubcategoryId !== null ? querySubcategoryId : subcategorySelectedId;
                this.selectedSubcategoryId =
                    allSubcategories.find((subcategory) => subcategory.id === selectedCategoryId)?.id ?? null;
                if (this.selectedSubcategoryId !== null && !this.isSidePanelOpen) {
                    this.togglePanel('workflows');
                }
            });
        }
    }
    toggleMenu() {
        this.isMenuOpen = !this.isMenuOpen;
    }
    togglePanel(type) {
        this.type = type;
        this.isSidePanelOpen = !this.isSidePanelOpen;
        if (!this.isSidePanelOpen) {
            this.clearGuidedWorkflowsSubcategoryCookie();
        }
    }
    closeMenu() {
        this.isSidePanelOpen = false;
        this.clearGuidedWorkflowsSubcategoryCookie();
    }
    clearSteps() {
        this.workflowsMenuComponent.clearSteps();
    }
    getPathName(pathname) {
        // Indicators don't use exchange symbols in URLs, but their name in snake case
        const indicatorsIdRegexSource = `(?!indicators(?:/|$))[a-z0-9_]+`;
        // We want to match only if after the ID there is either a slash or the end of the string.
        const securityIdRegex = pathname.includes('/indicators/')
            ? new RegExp(`/(?:${SECURITY_ID_REGEX_SOURCE}|${indicatorsIdRegexSource})(/|$)`)
            : new RegExp(`/(?:${SECURITY_ID_REGEX_SOURCE})(/|$)`);
        const decodeUriUntilStable = (str) => {
            let lastDecodedStr = str;
            try {
                let currDecodedStr = decodeURIComponent(str);
                // Iterate until decoding no longer changes the string
                while (currDecodedStr !== lastDecodedStr) {
                    lastDecodedStr = currDecodedStr;
                    currDecodedStr = decodeURIComponent(lastDecodedStr);
                }
                return lastDecodedStr;
            }
            catch {
                // If decoding fails for any reason, just return the last successfully decoded string
                return lastDecodedStr;
            }
        };
        // Pathname may be double-url-encoded, so we decode until it doesn't change. If it wasn't double-url-encoded, or
        // even single-url-encoded, decoding multiple times won't hurt.
        const decodedPathname = decodeUriUntilStable(pathname);
        return decodedPathname.replace(securityIdRegex, '/0/').replace(/^\//, '').replace(/\/$/, '');
    }
    clearGuidedWorkflowsSubcategoryCookie() {
        this.cookieService.delete(GUIDED_WORKFLOWS_OPEN_SUBCATEGORY_COOKIE_NAME, '/');
    }
}
SideMenuComponent.ɵfac = function SideMenuComponent_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || SideMenuComponent)(i0.ɵɵdirectiveInject(i0.ElementRef), i0.ɵɵdirectiveInject(i1.UrlsService), i0.ɵɵdirectiveInject(i2.FeatureService), i0.ɵɵdirectiveInject(i3.CookieService), i0.ɵɵdirectiveInject(i4.GuidedWorkflowsService)); };
SideMenuComponent.ɵcmp = /*@__PURE__*/ i0.ɵɵdefineComponent({ type: SideMenuComponent, selectors: [["ycn-side-menu"]], viewQuery: function SideMenuComponent_Query(rf, ctx) { if (rf & 1) {
        i0.ɵɵviewQuery(GuidedWorkflowsMenuComponent, 5);
    } if (rf & 2) {
        let _t;
        i0.ɵɵqueryRefresh(_t = i0.ɵɵloadQuery()) && (ctx.workflowsMenuComponent = _t.first);
    } }, hostBindings: function SideMenuComponent_HostBindings(rf, ctx) { if (rf & 1) {
        i0.ɵɵlistener("scroll", function SideMenuComponent_scroll_HostBindingHandler($event) { return ctx.onScrollEvent($event); }, false, i0.ɵɵresolveWindow);
    } }, inputs: { displaySecurityId: "displaySecurityId", securityId: "securityId", securityName: "securityName", securityUrl: "securityUrl", showQuickflows: "showQuickflows", pagePath: "pagePath" }, standalone: false, decls: 2, vars: 2, consts: [[1, "side-panel", "order-1", "open", 3, "top"], ["ycnTooltip", "", 1, "side-menu-toggler", 3, "click", "ngClass", "tooltipTitle", "tooltipPlacement", "tooltipIgnoreViewport"], ["ycnIcon", "", 3, "name"], [1, "side-menu", "order-2", 3, "ngClass"], [1, "side-menu-wrap"], [1, "side-menu-item", "side-menu-item-close"], ["ycnTooltip", "", 1, "btn", 3, "click", "tooltipTitle", "tooltipPlacement", "tooltipIgnoreViewport"], [1, "side-menu-item"], ["data-test-id", "quickflows-toggler", "ycnTooltip", "", 1, "btn", 3, "click", "ngClass", "tooltipTitle", "tooltipPlacement", "tooltipIgnoreViewport"], ["data-test-id", "workflows-toggler", "ycnTooltip", "", 1, "btn", 3, "click", "ngClass", "tooltipTitle", "tooltipPlacement", "tooltipIgnoreViewport"], [1, "side-panel", "order-1", "open"], [1, "side-panel-wrap"], [1, "side-panel-header", "bg-gray-base-90"], [1, "d-flex"], [1, "btn", "btn-circle", "btn-transparent", "btn-xs", "side-panel-toggler", 3, "click"], [1, "side-panel-content", 3, "displaySecurityId", "securityId", "securityName", "securityUrl"], [1, "side-panel-content", 3, "pagePath", "categories", "selectedSubcategoryId"], [1, "side-panel-title"], ["href", "javascript:void(0)", 1, "d-block", "text-gray-30", "text-underline"], ["href", "javascript:void(0)", 1, "d-block", "text-gray-30", "text-underline", 3, "click"], ["ycnTooltip", "", 1, "btn", "btn-circle", "btn-transparent2", "btn-xs", "ml-1", 3, "href", "tooltipTitle"]], template: function SideMenuComponent_Template(rf, ctx) { if (rf & 1) {
        i0.ɵɵtemplate(0, SideMenuComponent_Conditional_0_Template, 9, 16)(1, SideMenuComponent_Conditional_1_Template, 9, 7, "div", 0);
    } if (rf & 2) {
        i0.ɵɵconditional(ctx.showQuickflows || ctx.showWorkflows && ctx.categories.length ? 0 : -1);
        i0.ɵɵadvance();
        i0.ɵɵconditional(ctx.isSidePanelOpen ? 1 : -1);
    } }, dependencies: [i5.NgClass, i6.QuickflowsMenuComponent, i7.GuidedWorkflowsMenuComponent, i8.IconDirective, i9.TooltipDirective], styles: ["[_nghost-%COMP%] {\n                display: contents;\n            }"] });
